import { usePost } from "./usePost";

//components
import { BreadCrumbs, Button } from "@atoms";
import { Input, Accordion, Select } from "@molecules";

export const PostByCep = () => {
  const helper = usePost();

  if (helper.loading) {
    return <p>carregando...</p>;
  }

  return (
    <div>
      <BreadCrumbs items={["Posto", "Mais próximo"]} />

      <Input
        label="CEP"
        placeholder="Informe o cep"
        type="string"
        onValueChange={(e) => {
          helper.handleInputValue(e);
        }}
      />
      <br />

      <Select
        label="Linha"
        onChange={(e) => {
          helper.handleLine(e.target.value);
        }}
        value={helper.line}
        options={[
          { value: "ACE", label: "Acessórios" },
          { value: "Audio+e+Video", label: "Áudio e Vídeo" },
          { value: "AQC", label: "Aquecedor de gás" },
          { value: "RAD", label: "Auto Rádio" },
          { value: "BRA", label: "Branca" },
          { value: "BRP", label: "Branca Premium" },
          { value: "COK", label: "Cooktop" },
          { value: "Eletro+Eletronico", label: "Eletroeletrônicos" },
          { value: "ELE", label: "Eletro Portátil" },
          { value: "FER", label: "Ferramentas Elétricas" },
          { value: "INF", label: "Informática" },
          { value: "MQC", label: "Maquina de costura" },
          { value: "NTB", label: "Notebooks" },
          { value: "REFR", label: "Refrigeração" },
          { value: "SPL", label: "Split" },
          { value: "TEL", label: "Telefonia" },
          { value: "Televisores+e+Monitores", label: "Televisores e monitores" },
        ]}
      />

      <br />

      {helper.posts &&
        !helper.loading &&
        helper.posts.map((item) => (
          <div>
            <Accordion Title={item.nome}>
              <p className="w-full flex justify-between text-[14px]">
                <span className="text-[#87929D]">Código do posto</span>
                <span className="text-end max-w-[70%]">{item.codigo_posto ?? "-"}</span>
              </p>
              <p className="w-full flex justify-between text-[14px]">
                <span className="text-[#87929D]">Endereço</span>
                <span className="text-end max-w-[70%]">{item.contato_endereco ?? "-"}</span>
              </p>
              <p className="w-full flex justify-between text-[14px]">
                <span className="text-[#87929D]">Número</span>
                <span className="text-end max-w-[70%]">{item.contato_numero ?? "-"}</span>
              </p>
              <p className="w-full flex justify-between text-[14px]">
                <span className="text-[#87929D]">Complemento</span>
                <span className="text-end max-w-[70%]">{item.contato_complemento ?? "-"}</span>
              </p>
              <p className="w-full flex justify-between text-[14px]">
                <span className="text-[#87929D]">Bairro</span>
                <span className="text-end max-w-[70%]">{item.contato_bairro ?? "-"}</span>
              </p>
              <p className="w-full flex justify-between text-[14px]">
                <span className="text-[#87929D]">Cidade</span>
                <span className="text-end max-w-[70%]">{item.contato_cidade ?? "-"}</span>
              </p>
              <p className="w-full flex justify-between text-[14px]">
                <span className="text-[#87929D]">E-mail</span>
                <span className="text-end max-w-[70%]">{item.contato_email ?? "-"}</span>
              </p>
              <p className="w-full flex justify-between text-[14px]">
                <span className="text-[#87929D]">Telefone</span>
                <span className="text-end max-w-[70%]">{item.fone ?? "-"}</span>
              </p>
              <p className="w-full flex justify-between text-[14px]">
                <span className="text-[#87929D]">Distância</span>
                <span className="text-end max-w-[70%]">
                  {item.distance ? helper.formatDistance(Number(item.distance)) : "-"}
                </span>
              </p>
            </Accordion>
          </div>
        ))}

      <div className="w-full border-t border-[#D8DCDE] flex flex-col gap-[20px] mt-[10px] bg-white">
        <Button onClick={helper.handleSearch}>Buscar Posto</Button>
        <Button onClick={helper.backPage}>Voltar</Button>
      </div>
    </div>
  );
};
